import { render, staticRenderFns } from "./singlesTable.vue?vue&type=template&id=2b78647e"
import script from "./singlesTable.vue?vue&type=script&lang=js"
export * from "./singlesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports